import styled from 'styled-components';
export var Wrapper = /*#__PURE__*/styled.section.withConfig({
  componentId: "sc-1ehebjx-0"
})(["width:100%;h2{font-family:'IntervalNextReg',sans-serif;font-size:", ";line-height:", ";font-weight:600;color:", ";}"], function (props) {
  return props.theme.rem(22);
}, function (props) {
  return props.theme.rem(26);
}, function (props) {
  return props.theme.rentalConditionsSection.text.color;
});
export var List = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1ehebjx-1"
})(["display:flex;flex-direction:column;", " margin-top:", ";.text-strike-through{text-decoration:line-through;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(5, 'column');
}, function (props) {
  return props.theme.space(6);
});